export default {
  "retentionRate.title": "Retention Rate",
  "retentionRate.column.no": "#NO",
  "retentionRate.column.statisticsTime": "Date",
  "retentionRate.column.registerNum": "Registered Users",
  "retentionRate.search.statisticsTime": "Date",
  "retentionRate.column.id": "ID",
  "retentionRate.column.registerCount": "Register Count",
  "retentionRate.column.firstDepositCount": "First Deposit Count",
  "retentionRate.column.secondDayDepositCount": "2nd Day Deposit Count",
  "retentionRate.column.depositRetainRate": "Deposit Retain Rate",
  "retentionRate.column.secondDayPlayerCount": "2nd Day Player Count",
  "retentionRate.column.retainRate": "Retain Rate",
  "retentionRate.column.secondDayRetainCount": "2nd Day Retain Count",
  "retentionRate.column.playerRetainRate": "Player Retain Rate",
  "retentionRate.column.thirdDayRetainCount": "3rd Day Retain Count",
  "retentionRate.column.fourthDayRetainCount": "4th Day Retain Count",
  "retentionRate.column.fifthSeventhDayRetainCount": "5th-7th Day Retain Count",
  "retentionRate.column.eighthThirtyDayRetainCount": "8th-30th Day Retain Count",
  "retentionRate.column.thirtyDayRetainCount": "30th Day Retain Count",
  "retentionRate.column.statisticsTimezoneName": "Statistics Timezone",
  "retentionRate.column.statisticsTimeDesc": "Statistics Time",
  "retentionRate.column.action": "Action",
  "retentionRate.column.details": "Details",
};